import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Item from './Item';
import { getEducationals } from '../api/api';

const styles = theme => ({
  root: {
    margin: '30px 0px'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '50px 0'
  }
});

class Educationals extends Component {

  state = {
    educationals: [],
    loading: true
  }

  async componentDidMount() {
    try {
      const response = await getEducationals();
      const educationals = response.items.map(item => ({
        id: item.id,
        image: item.imageUrl,
        link: item.link,
        title: item.description
      }));
      this.setState({ educationals, loading: false });
    } catch (err) {
      console.error('Failed to load educationals:', err);
      this.setState({ loading: false });
    }
  }

  render() {
    const { classes } = this.props;
    const { educationals, loading } = this.state;

    if (loading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="flex-start"
        >
          {educationals.map(edu => <Item key={edu.id} section={edu} clickable width={4} type="photo" /> )}
        </Grid>
      </div>
    )
  }
}

Educationals.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Educationals);
